import * as React from 'react';
import { AddEntry } from './addEntry';
import { EntryDictionary, EntryList, EntrySelectedHandlerType } from './entryList';
import '../styles/entryListPane.css';

interface EntryListPaneProps {
  entries: EntryDictionary;
  onEntrySelected: EntrySelectedHandlerType;
  selectedEntryId: string;
  onAddEntry: () => void;
}

export const EntryListPane: React.SFC<EntryListPaneProps> = (props) => {
  return (
    <div className="entryListPane">
      <AddEntry onClick={props.onAddEntry}/>
      <EntryList
        entries={props.entries}
        onEntrySelected={props.onEntrySelected}
        selectedEntryId={props.selectedEntryId}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/entryListPane.tsx